import React from "react";
import Footer from "./Footer";
import "../App.css";
import { useLocation } from "react-router-dom";
import HomeIcon from "./HomeIcon";

function Layout({ children }) {
  const location = useLocation();
  const path = location?.pathname || "";

  // ❌ NICHT anzeigen auf Home (/) und Browse (/browse + Unterseiten)
  const hideHomeIcon =
    path === "/" || path === "/browse" || path.startsWith("/browse/");

  return (
    <div className="layout-wrapper">
      {!hideHomeIcon && <HomeIcon />}

      <main className="layout-content">
        {children}
      </main>

      <Footer />
    </div>
  );
}

export default Layout;